import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { UiLanguageSelectorComponent } from '@components/ui-language-selector/ui-language-selector.component';
import { DirectivesModule } from '@directives/directives.module';
import { TranslateModule } from '@ngx-translate/core';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        MatIconModule,
        MatSelectModule,
        TranslateModule,
        UiNgLetModule,
    ],
    declarations: [
        UiLanguageSelectorComponent,
    ],
    exports: [
        UiLanguageSelectorComponent,
    ],
})
export class UiLanguageSelectorModule { }
